import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";
import type { IBrandfetchBrand } from "@/shared/types";
import type { IMediaLibLogo } from "../types";

interface IState {
  logosData: IMediaLibLogo[];
  brand: IBrandfetchBrand | null;
  query: string;
}

interface IActions {
  setLogosData: (value: IMediaLibLogo[]) => void;
  updateLogoData: (idx: number, value: Partial<IMediaLibLogo>) => void;
  setBrand: (value: IBrandfetchBrand | null) => void;
  setQuery: (value: string) => void;
  reset: () => void;
}

const initState: IState = {
  logosData: [],
  brand: null,
  query: "",
};

export const useLogosStore = create<IState & IActions>((set) => ({
  ...initState,
  setLogosData: (logosData) => set({ logosData }),
  updateLogoData: (idx, data) => {
    set((s) => {
      const prev = s.logosData;
      if (prev[idx] == null) {
        return s;
      }
      const tmp = [...prev];
      tmp[idx] = {
        ...tmp[idx],
        ...data,
      };
      return { logosData: tmp };
    });
  },
  setBrand: (brand) => set({ brand }),
  setQuery: (query) => set({ query }),
  reset: () => set(initState),
}));

export const useLogosStoreShallow = <U>(
  selector: (store: IState & IActions) => U,
) => {
  return useLogosStore(useShallow(selector));
};
